import React from "react";
import { Document, Page } from "react-pdf";

/* eslint-disable @typescript-eslint/ban-types */
interface ResumeCardProps {
  width: number;
  data: any;
  filename: string;
  callback: (template_name: string) => void;
}
/* eslint-enable @typescript-eslint/ban-types */

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const ResumeCard: React.FC<ResumeCardProps> = ({
  width,
  data,
  filename,
  callback,
}) => {
  const pdfData = React.useMemo(() => {
    return { data: atob(data) };
  }, [data]);
  return (
    <div className={`flex w-full flex-col items-center border-2 border-black`}>
      <button className="w-full" onClick={() => callback(filename)}>
        <Document file={pdfData} options={options}>
          <Page
            pageNumber={1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
            width={width}
          >
            <h1 className="pl-2 text-left font-code font-bold">{filename}</h1>
          </Page>
        </Document>
      </button>
    </div>
  );
};

export default ResumeCard;
